import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/content";
import { useSeo } from "@/hooks/useSeo";

export default function Privacy() {
  useSeo("Privacy Policy | RD Cleaning Services Perth", "Privacy policy for RD Cleaning Services, Perth WA — how we handle your personal information.");
  return (
    <>
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="How RD Cleaning Services collects, uses and protects your information." image={IMG.interior} />
      <section className="bg-white py-16 sm:py-24">
        <Reveal className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <div className="prose-slate space-y-8 text-sm leading-relaxed text-slate-600 sm:text-base">
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Information We Collect</h2>
              <p className="mt-3">When you submit an enquiry through this website, we collect the details you provide — such as your name, phone number, email address, suburb, property details and your message — so we can respond to your enquiry and prepare a quote.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">How We Use Your Information</h2>
              <p className="mt-3">Your information is used only to respond to your enquiry, provide quotes and deliver cleaning services. We do not sell or share your personal information with third parties for marketing purposes.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Data Security</h2>
              <p className="mt-3">Enquiries are stored securely and access is restricted to authorised team members. If you would like your enquiry details removed, contact us and we will delete them.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Contact</h2>
              <p className="mt-3">For any privacy questions, contact RD Cleaning Services at [EMAIL ADDRESS] or [PHONE NUMBER]. Business address: [BUSINESS ADDRESS].</p>
            </div>
            <p className="text-xs text-slate-400">Last updated: July 2026. This policy will be finalised with verified business details before launch.</p>
          </div>
        </Reveal>
      </section>
    </>
  );
}
